import './BatterApproachPerCountChart.scss';

import CountChart, { CountChartData, counts } from 'components/Charts/CountChart/CountChart';
import Legend, { LegendItem } from 'components/Charts/Legend/Legend';
import { useMemo } from 'react';
import { ApproachPerCountChartConfigDto, ApproachPerCountChartDto, ApproachPerCountOptions } from 'types/CodegenReportTypes';

import { ChartProps } from 'utilities/chartIdToComponent';
import { approachToColor } from 'utilities/colorHelpers';

const approachTypes: ApproachPerCountOptions[] = ['Take', 'Swing'];
const legendItems: LegendItem[] = approachTypes.map((approachType) => ({
  label: approachType,
  dotProps: { color: approachToColor[approachType] },
}));

const BatterApproachPerCountChart = ({
  chartData,
  isLoading,
  chartConfig,
}: ChartProps<ApproachPerCountChartDto, ApproachPerCountChartConfigDto>) => {
  const countChartData = useMemo(
    () =>
      counts.reduce((map, count) => {
        const approachPerCount = chartData?.approachPerCountList.find((x) => x.count === count);
        map.set(count, [
          {
            value: approachPerCount?.swing ?? 0,
            color: approachToColor.Swing,
          },
          {
            value: approachPerCount?.take ?? 0,
            color: approachToColor.Take,
          },
        ]);
        return map;
      }, new Map() as CountChartData),
    [chartData]
  );

  const filteredLegendItems = useMemo(() => {
    if (!chartData) {
      return [];
    }

    const hasTakeData = chartData.approachPerCountList.some((item) => item.take > 0);
    const hasSwingData = chartData.approachPerCountList.some((item) => item.swing > 0);

    return legendItems.filter((item) => {
      if (item.label === 'Take') {
        return hasTakeData;
      }
      if (item.label === 'Swing') {
        return hasSwingData;
      }
      return false;
    });
  }, [chartData]);

  return (
    <div className='BatterApproachPerCountChart-container'>
      <CountChart chartData={countChartData} isLoading={isLoading} colorsToSimulate={[approachToColor.Take, approachToColor.Swing]} />
      <Legend items={filteredLegendItems} />
    </div>
  );
};

export default BatterApproachPerCountChart;
